import moment from "moment";
export var getAge = function (birthdateStr) {
    var birthdate = moment(birthdateStr, "YYYY-MM-DD");
    var today = moment();
    var age = today.diff(birthdate, "years");
    return age;
};
